export enum ProfileField {
  FirstName = 'name',
  Email = 'email',
  PhoneNumber = 'phoneNumber',
  Role = 'role',
}

export type ProfileFormValues = {
  [ProfileField.FirstName]: string;
  [ProfileField.Email]: string;
  [ProfileField.PhoneNumber]: string;
  [ProfileField.Role]: string;
};
